<div class="historical-position-dialog">
  <div class="historical-position-dialog__title dv-headline-lg">
    {{ 'HistoricalPositionDialog.Title' | translate }}
  </div>
  <div class="historical-position-dialog__content">
    <dv-dynamic-form
      [elements]="elements | translateElements"
      [formGroup]="formGroup"></dv-dynamic-form>
    <div class="historical-position-dialog__content--action">
      <dv-button (click)="onCancel()">{{
        'General.Cancel' | translate
      }}</dv-button>
      <dv-button
        [disabled]="
          !formGroup.value.dateAndTime || !formGroup.dirty || !formGroup.valid
        "
        (click)="onConfirmClick()"
        color="secondary"
        >{{ 'General.Confirm' | translate }}</dv-button
      >
    </div>
  </div>
</div>
